"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
// these are base styles that can be built upon for specific button use cases
// many of these properties are simply resetting values
// much of this is inspired by Material-UI's ButtonBase
const StyledButtonBase = styled_components_1.default.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  --webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0; // removes the focus ring - remember to add event listeners for people navigating using keyboards (for accessbility reasons)
  border: 0;
  margin: 0; // removes the margin in Safari
  padding: 0; // removes the padding in Firefox
  border-radius: 0;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
  --moz-appearance: none;
  --webkit-appearance: none;
  text-decoration: none; // to override the default style of a native <a /> element
  letter-spacing: normal; // to override the default style of a native <a /> element
  color: inherit;
  &::-moz-focus-inner {
    border-style: none; // removes Firefox dotted outline
  }

  ${({ disabled }) => disabled &&
    styled_components_1.css `
      pointer-events: none;
      cursor: default;
    `}
`;
/**
 * A base button component that contains solely base styles
 * @name ButtonBase
 * @param {node} children - button text
 * @param {string} className - className props in case we want to add custom styling
 * @param {boolean} disabled - enabled/disables the button
 * @param {string} href - the URL to link to when the button is clicked.
 * @param {func} onClick - a function that is executed when the button is clicked
 */
const ButtonBase = react_1.default.forwardRef((_a, ref) => {
    var { className, children, href, disabled = false } = _a, others = __rest(_a, ["className", "children", "href", "disabled"]) // used to receive any native HTML element props
    ;
    // render button as <a /> if href is present
    let asValue = null;
    if (href)
        asValue = "a";
    return (react_1.default.createElement(StyledButtonBase, Object.assign({ className: className, disabled: disabled, href: href, as: asValue, ref: ref }, others), children));
});
ButtonBase.defaultProps = {
    className: "",
    children: null,
    disabled: false,
    href: "",
};
exports.default = ButtonBase;
//# sourceMappingURL=ButtonBase.js.map